import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export const OnlineCourses = () => {
  // Add dark mode state
  const [darkMode, setDarkMode] = useState(() => {
    // Check localStorage for saved preference, default to dark mode
    const savedMode = localStorage.getItem('studentDashboardTheme');
    return savedMode === 'dark' || !savedMode; // Default to dark mode if not set
  });
  // Listen for theme changes
  useEffect(() => {
    const handleThemeChange = event => {
      setDarkMode(event.detail.darkMode);
    };
    window.addEventListener('themeChange', handleThemeChange);
    return () => {
      window.removeEventListener('themeChange', handleThemeChange);
    };
  }, []);
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Define text color classes based on dark mode
  const textColorClass = darkMode ? 'text-white' : 'text-gray-800';
  const subtextColorClass = darkMode ? 'text-gray-300' : 'text-gray-600';
  const sectionBgClass = darkMode ? 'bg-white/5' : 'bg-white';
  const borderClass = darkMode ? 'border-white/10' : 'border-gray-200';
  return <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-5387">
      {/* Header */}
      <div className="mb-12" data-id="element-5388">
        <h1 className={`text-3xl md:text-4xl font-bold ${textColorClass} mb-3`} data-id="element-5389">
          Courses — Coming Soon
        </h1>
        <p className={`text-lg ${subtextColorClass}`} data-id="element-5390">
          Maestro Connect is preparing a dedicated courses section focused on
          high-quality music education.
        </p>
        <p className={`text-lg ${subtextColorClass} mt-2`} data-id="element-5391">
          This area will feature structured courses created by experienced
          musicians and educators, covering a wide range of topics across
          instruments, theory, and the music industry.
        </p>
      </div>

      {/* What This Section Will Offer */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5392">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5393">
          What This Section Will Offer
        </h2>
        <ul className={`space-y-3 ${subtextColorClass}`} data-id="element-5394">
          <li className="flex items-start" data-id="element-5395">
            <span className="mr-3" data-id="element-5396">•</span>
            <span data-id="element-5397">
              Instrument-focused courses (piano, guitar, violin, drums, and
              more)
            </span>
          </li>
          <li className="flex items-start" data-id="element-5398">
            <span className="mr-3" data-id="element-5399">•</span>
            <span data-id="element-5400">Music theory, harmony, and composition</span>
          </li>
          <li className="flex items-start" data-id="element-5401">
            <span className="mr-3" data-id="element-5402">•</span>
            <span data-id="element-5403">Music business, publishing, and career education</span>
          </li>
          <li className="flex items-start" data-id="element-5404">
            <span className="mr-3" data-id="element-5405">•</span>
            <span data-id="element-5406">
              Courses created by professional educators and working musicians
            </span>
          </li>
        </ul>
      </section>

      {/* How Courses Will Be Selected */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5407">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5408">
          How Courses Will Be Selected
        </h2>
        <p className={`${subtextColorClass} mb-4`} data-id="element-5409">
          Our goal is quality and credibility.
        </p>
        <p className={`${subtextColorClass} mb-3`} data-id="element-5410">Courses may include:</p>
        <ul className={`space-y-3 ${subtextColorClass} mb-4`} data-id="element-5411">
          <li className="flex items-start" data-id="element-5412">
            <span className="mr-3" data-id="element-5413">•</span>
            <span data-id="element-5414">
              Original courses created specifically for Maestro Connect
            </span>
          </li>
          <li className="flex items-start" data-id="element-5415">
            <span className="mr-3" data-id="element-5416">•</span>
            <span data-id="element-5417">Collaborations with established educators and creators</span>
          </li>
          <li className="flex items-start" data-id="element-5418">
            <span className="mr-3" data-id="element-5419">•</span>
            <span data-id="element-5420">
              Carefully selected third-party educational content where
              appropriate
            </span>
          </li>
        </ul>
        <p className={`${subtextColorClass}`} data-id="element-5421">
          Each course will be reviewed to ensure it provides clear educational
          value and practical learning outcomes.
        </p>
      </section>

      {/* Status */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5422">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5423">Status</h2>
        <p className={`${subtextColorClass}`} data-id="element-5424">
          This section is currently under development and will launch after the
          core platform release. Courses will be added gradually.
        </p>
      </section>

      {/* Get Notified */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} text-center`} data-id="element-5425">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5426">
          Get Notified
        </h2>
        <p className={`${subtextColorClass} mb-6`} data-id="element-5427">
          Join the waitlist to be notified when courses become available.
        </p>
        <Link to="/" className="inline-block bg-deep-pink hover:bg-burgundy text-white font-medium py-3 px-8 rounded-lg transition-colors" data-id="element-5428">
          Join the Waitlist
        </Link>
      </section>
    </div>;
};